import { Home } from "@mui/icons-material";
import { Breadcrumbs as MuiBreadcrumbs, IconButton } from "@mui/material";

import Box from "../Box";
import Typography from "../Typography";
import Helpers from "../../commons/helpers";

interface Props {
    title: string;
    light?: boolean;
    route?: {
        title: string;
        route: string;
    }[];
    pathNameHome: string;
    onNavigate: (pathName: string) => void;
    [key: string]: any;
}

const Breadcrumbs: React.FC<Props> = ({ title, route, light, pathNameHome, onNavigate }: Props) => {

    return (
        <Box mr={{ xs: 0, xl: 8 }}>
            <MuiBreadcrumbs
                sx={{
                    "& .MuiBreadcrumbs-separator": {
                        color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
                    },
                }}
            >
                <IconButton onClick={() => { onNavigate(pathNameHome) }}>
                    <Typography
                        component="span"
                        variant="body2"
                        color={light ? "white" : "dark"}
                        opacity={light ? 0.8 : 0.5}
                        sx={{ lineHeight: 0 }}
                    >
                        <Home />
                    </Typography>
                </IconButton>
                {([...route || []].length > 0)
                    && route.map((el) => (
                        <IconButton
                            key={el.title}
                            onClick={() => {
                                if (!Helpers.isNullOrEmpty(el.route)) {
                                    onNavigate(el.route);
                                }
                            }}
                        >
                            <Typography
                                component="span"
                                variant="button"
                                fontWeight="regular"
                                textTransform="none"
                                color={light ? "white" : "dark"}
                                opacity={light ? 0.8 : 0.5}
                                sx={{ lineHeight: 0 }}
                            >
                                {el.title}
                            </Typography>
                        </IconButton>
                    ))
                }
            </MuiBreadcrumbs>
            <Typography
                noWrap
                variant="h5"
                fontWeight="bold"
                textTransform="none"
                sx={{ paddingLeft: "10px" }}
                color={light ? "white" : "dark"}
            >
                {title}
            </Typography>
        </Box>
    );
}

Breadcrumbs.defaultProps = {
    light: false,
};

export default Breadcrumbs;
